import React from "react";
import { LoadingAnimation } from "../../LoadingAnimation/LoadingAnimation";

interface BookingSearchProps {
  message: string | undefined;
}

export const BookingSearchLoading: React.FC<BookingSearchProps> = ({
  message,
}) => {
  return (
    <div className="InitialStep__searchFallback">
      <LoadingAnimation text={message ? message : "Laster resultater"} />
    </div>
  );
};
